import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/topics";

export default function BrandSection() {
  return (
    <section id="about" className="bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-8xl">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20a%20warm%20cream%20reading%20desk%20with%20open%20notebooks%20stacked%20papers%20a%20brass%20desk%20lamp%20and%20a%20cup%20of%20tea%2C%20soft%20natural%20window%20light%2C%20muted%20vermillion%20and%20amber%20accents%2C%20calm%20thoughtful%20archival%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail&width=1200&height=1400&seq=hc-about-01&orientation=portrait"
                alt="黑料吃话 编辑部的整理工作台"
                title="黑料吃话 · 编辑部工作台"
                className="h-[320px] w-full object-cover object-top md:h-[460px]"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <SectionHeading
              eyebrow="关于我们"
              title="把复杂的事，整理成可读的文字"
              description="黑料吃话是一个以「文字实录」为核心的内容平台。我们不追逐第一时间的声量，而是用更慢一点的方式，把事情理清楚。"
            />
            <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              <p>
                在信息碎片化的环境里，同一条消息常常有多个版本，情绪跑在事实前面。
                我们尝试做的，是把公告、记录、回应按时间顺序摆在一起，让读者能够自己判断。
              </p>
              <p>
                每一份档案都会经过交叉验证，凡是有分歧的节点都会被标注出来。
                我们相信，把不确定性诚实地说出来，比给一个看似确定的结论更有价值。
              </p>
            </div>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                了解更多
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/topics"
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                浏览话题归档
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-background-200 pt-12">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">读者怎么说</h3>
          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
              >
                <span className="font-heading text-3xl leading-none text-accent-500 quote-mark" />
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                    {item.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}